import { nanoid } from "nanoid";
import { defineStore } from "pinia";
import { ofetch } from "ofetch";
import localforage from "localforage";

export const useSettingsStore = defineStore("settings", () => {
  const cacheStorage = localforage.createInstance({
    name: "settingStore",
  });
  cacheStorage.setDriver(localforage.LOCALSTORAGE);

  const sid = ref(nanoid(8));
  const settings = ref(null);

  async function loadSettings() {
    const cachedSettings = await cacheStorage.getItem("settings");
    if (cachedSettings) {
      settings.value = cachedSettings;
      fetchRemoteSettings();
      return cachedSettings;
    } else {
      const remoteSettings = await fetchRemoteSettings();
      if (remoteSettings) {
        settings.value = remoteSettings;
        return remoteSettings;
      } else {
        throw new Error("Failed to load settings");
      }
    }
  }

  async function fetchRemoteSettings() {
    if (navigator.onLine === false) return false;
    try {
      let response = await ofetch(`/n/api/public/settings?v=${import.meta.env.VITE_VUE_APP_RELEASE || "web"}`, {
        baseURL:
          localStorage.getItem("baseUrl") ||
          import.meta.env.VITE_VUE_APP_API_BASE_PATH ||
          (window.cordova?.platformId ? "https://go.preprod.alvarum.com/" : window.location.origin + "/"),
        retryDelay: 600,
        retry: 5,
        headers: {
          Sid: sid.value,
          "X-App-Version": import.meta.env.VITE_VUE_APP_RELEASE || "alvarum-go-" + (window.cordova?.platformId || "web") + "@dev",
          ...(window.device && { "X-Device": `${window.device.version}:${window.device.manufacturer} ${window.device.model}` }),
        },
        responseType: "json",
      });
      if (response) {
        await cacheStorage.setItem("settings", response);
        return response;
      }
    } catch (err) {
      console.error("Failed to load settings:", err);
    }
    return false;
  }

  function setSettings(settingsData) {
    settings.value = settingsData;
  }

  return {
    settings,
    sid,
    loadSettings,
    setSettings,
  };
});
